import { getFirestoreData, getFirestoreDocument } from 'store/actions/firestoreActions.jsx'
import { db } from "firebase/fbConfig.js"
import moment from 'moment'

// export const startSetVendorsList = () => {
//   return (dispatch) => {
//     console.log("hello")
//     // Get firestore Data and convert it to tableData format
//     getFirestoreData("haney-vendors")
//       .then(data => {
//         // create dataRows and expandedData from data
//         let dataRows = []
//         let expandedData = {}        
//         data.map(row => {          
//           // add to dataRows array        
//           let rowArr = [];
//           rowArr.push(row.docid);
//           rowArr.push(row.name);
//           rowArr.push(row.physicalAddress);
//           dataRows.push(rowArr);

//           // add to expandedData Object
//           expandedData = {
//             ...expandedData,
//             [row.id]: row
//           }
//         })
//         dispatch(setVendorsList(dataRows, expandedData))
//       })    
//   }
// }


export const startSetVendorsList = () => {
  return (dispatch) => {
    db.collection("haney-vendors")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {        
        dispatch(setVendorsList(data))
      })
  }
}

export const setVendorsList = (dataRows, expandedData) => ({
  type: 'SET_VENDORS_LIST',
  dataRows,
  expandedData
})

export const startSetVendorTrucksList = () => {
  return (dispatch) => {
    db.collection("haney-vendors").doc("3eEFN7K55c9sSnGf5pI6").collection("trucks")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {        
        dispatch(setVendorTrucksList(data))
      })
  }
}

export const setVendorTrucksList = (dataRows, expandedData) => ({
  type: 'SET_VENDOR_TRUCKS_LIST',
  dataRows,
  expandedData
})


// WEBPACK FOOTER //
// ./src/store/actions/vendorsActions.jsx